import '../styles/layers-panel.css';

import { store } from '../state';
import { /*getLayerById,*/ getLayerState, getGroupVisibility, /*getGroupCheckState,*/ setLayerVisibility, setGroupVisibility } from '../layers';
import { getConfig, getConfigOptional } from '../config';

const els = {
  layersPanel: document.getElementById('layers-panel') as HTMLElement,
  layersPanelContent: document.getElementById('layers-panel-content') as HTMLElement,
};

function getGroupCheckboxState(groupId: string): { checked: boolean } {
  return { checked: getGroupVisibility(groupId) };
}

export function renderLayersPanel(): void {
  let html = '';
//  const appConfig = getConfig('main');//(window as any).__APP_CONFIG__;
  const layersConfig = getConfig('layers');//appConfig?.layers;
  
  if (!layersConfig) return;

  layersConfig.groups.forEach((group: any) => {
    // 1. Если группа помечена как скрытая, пропускаем её целиком
    if (group.hidden) return;

    // 2. Фильтруем слои внутри группы: оставляем только те, у которых нет hidden: true
    const visibleLayers = (group.layers || []).filter((layer: any) => !layer.hidden);

    // 3. Если после фильтрации в группе не осталось слоёв, не рисуем даже заголовок группы
    if (visibleLayers.length === 0) return;

    const groupVisible = group.toggleable ? getGroupVisibility(group.id) : true;

    // Чекбокс группы (если toggleable)
    let groupCheckboxHtml = '';
    if (group.toggleable) {
      const groupChecked = group.toggleable ? getGroupCheckboxState(group.id).checked : true;
      const checkedAttr = groupChecked ? 'checked' : '';
      groupCheckboxHtml = `
        <input type="checkbox" 
               class="group-toggle"
               ${checkedAttr}
               data-group-id="${group.id}"
               aria-label="Переключить группу ${escapeHtml(group.name)}">
      `;
    }

    // Класс для группы, если она выключена
    const groupClass = !groupVisible ? 'layers-group disabled' : 'layers-group';

    html += `
      <div class="${groupClass}">
        <div class="layers-group-header">
          ${groupCheckboxHtml}
          <div class="layers-group-title">${escapeHtml(group.name)}</div>
        </div>
    `;
    
    visibleLayers.forEach((layer: any) => {
      const layerState = getLayerState(layer.id);
      const inputType = group.exclusive ? 'radio' : 'checkbox';
      const groupName = group.exclusive ? `name="layer-group-${group.id}"` : '';

      // Если группа выключена — слой "заблокирован"
      const isDisabled = !groupVisible;
      const disabledAttr = isDisabled ? 'disabled' : '';
      const itemClass = `layer-item ${layerState ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`;
      
      html += `
        <div class="${itemClass}">
          <input type="${inputType}" 
                 id="layer-${layer.id}" 
                 ${groupName}
                 ${layerState ? 'checked' : ''}
                 ${disabledAttr}
                 data-layer-id="${layer.id}"
                 data-group-id="${group.id}"
                 data-exclusive="${group.exclusive}">
          <label for="layer-${layer.id}">${escapeHtml(layer.name)}</label>
        </div>
      `;
    });
    html += `</div>`;
  });

  els.layersPanelContent.innerHTML = html;
}

export function initLayersPanel(): void {
  console.log('🔧 Инициализация панели слоёв');

  els.layersPanelContent.addEventListener('change', (e) => {
    const target = e.target as HTMLInputElement;
    
    // 1. Обработка чекбокса ГРУППЫ
    if (target.classList.contains('group-toggle') && target.dataset.groupId) {
      const groupId = target.dataset.groupId;
      const visible = target.checked;
      console.log(`📂 Переключение группы ${groupId}: ${visible}`);
      setGroupVisibility(groupId, visible);
      renderLayersPanel();
      return;
    }
    
    //2. обработка переключателя слоя
    if (target.dataset.layerId) {
      const layerId = target.dataset.layerId;
      const visible = target.checked;
      const isExclusive = target.dataset.exclusive === 'true';
      const groupId = target.dataset.groupId;
      
      console.log('target.dataset = ', target.dataset);
      
      // Если группа выключена — игнорируем клик по слою
      if (groupId && !getGroupVisibility(groupId)) {
        renderLayersPanel(); // Просто перерисовываем, чтобы сбросить состояние
        return;
      }

      if (isExclusive && groupId && visible) {
        console.log('toggle exclusive layer');
        // Для exclusive-групп: выключаем ВСЕ слои группы, включаем только выбранный
        const layersConfig = getConfigOptional('layers');
        if (layersConfig) {
          console.log('config found');
          const group = findGroupById(layersConfig, groupId);
          console.log('group is ', group);
          if (group && group.layers) {
            group.layers.forEach((layer: any) => {
              if (!layer.hidden) {
                setLayerVisibility(layer.id, layer.id === layerId);
              }
            });
          }
        }
      }
      setLayerVisibility(layerId, visible);
      renderLayersPanel();
    }
  });

  store.subscribe(() => {
    const state = store.getState();
    if (state.currentView === 'map') {
      const w = getComputedStyle(document.documentElement).getPropertyValue('--layers-panel-width').trim();
      document.documentElement.style.setProperty('--left-panel-offset', w);
//      els.layersPanel.style.display = 'flex';
      renderLayersPanel();
    } else {
      document.documentElement.style.setProperty('--left-panel-offset', '0px');
//      els.layersPanel.style.display = 'none';
    }
  });

  const initialState = store.getState();
  if (initialState.currentView === 'map') {
    const w = getComputedStyle(document.documentElement).getPropertyValue('--layers-panel-width').trim();
    document.documentElement.style.setProperty('--left-panel-offset', w);
//    els.layersPanel.style.display = 'flex';
    renderLayersPanel();
  } else {
    document.documentElement.style.setProperty('--left-panel-offset', '0px');
//    els.layersPanel.style.display = 'none';
  }
}

function findGroupById(config: any, groupId: string): any {
  for (const group of config.groups) {
    if (group.id === groupId) return group;
    if (group.groups) {
      for (const subgroup of group.groups) {
        if (subgroup.id === groupId) return subgroup;
      }
    }
  }
  return null;
}

function escapeHtml(str: string): string {
  if (str === null || str === undefined) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}